import PT from 'prop-types';
import { useState } from 'react';

// mui imports
import { Card } from '@mui/material';

// sideBar components
import SideCardHeader from './SideCardHead';
import SideCardBody from './SideCardBody';

const SideCard = props => {
  const { cardHead, cardBody } = props;

  //  use States
  const [toggle, setToggle] = useState(true);

  const sideCardHeadProps = { ...cardHead, toggle: toggle, setToggle: setToggle },
    sideCardBodyProps = { ...cardBody, toggle: toggle };

  return (
    <Card
      sx={{
        bgcolor: `#e0e5ec !important`,
        boxShadow: `0.3rem 0.3rem 0.5rem #6b6868, -0.2rem -0.2rem 0.4rem #fff !important`,
        borderRadius: '25px',
        padding: '10px'
      }}>
      <SideCardHeader {...sideCardHeadProps} />
      <SideCardBody {...sideCardBodyProps} />
    </Card>
  );
};

SideCard.propTypes = {
  cardHead: PT.object.isRequired,
  cardBody: PT.object.isRequired
};

export default SideCard;
